import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../../assets/wemeettologowhite.svg';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-logo">
            <img src={logo} alt="Wemeetto" className="footer-logo-image" />
          </div>
          <div className="footer-links">
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/faq">FAQ's</Link>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} wemeetto. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


